import { State } from "../../../state";
import { ApplyActionVisibility } from "../_CostsAndOutcomes/ApplyActionVisibility";
import { ApplyCostsBrickPack } from "../_CostsAndOutcomes/BrickPacks/ApplyCostsBrickPack";
import { ApplyOutcomesBrickPack } from "../_CostsAndOutcomes/BrickPacks/ApplyOutcomesBrickPack";
import { meetsCostRequirementsBrickPack } from "../_CostsAndOutcomes/BrickPacks/meetsCostRequirementsBrickPack";
import { applyAchievementChecks } from "../../../Achievements/checkAchievements";

export const BuyBrickPack = (
  actionId: string,
  state: State,
  buyAmount: number,
) => {
  if (actionId === "invalid") return state;

  const newBricks = new Map(state.bricks);
  const newSets = new Map(state.sets);
  const newActions = new Map(state.actions);
  const newActionTimestamps = state.actionTimestamps;
  const newBrickPackHistory = state.brickPackHistory;
  const newBrickPackStats = state.brickPackStats;
  const newBricksCollectedByType = state.bricksCollectedByType;

  const action = new Map(state.actions).get(actionId)!;

  // Check if action meets cost requirements
  // buyAmount == total packs purchased
  if (!meetsCostRequirementsBrickPack(action, newBricks, newSets, buyAmount)) {
    return state;
  }

  // Apply Action Visibility
  const { newActions: updatedActions, newActionOrder } = ApplyActionVisibility(
    action,
    newActions,
    state.actionOrder,
  );

  // Apply Costs
  // null = result of applied costs are negative.  Should be caught during meetCostRequirementsQuickBuy
  const costsResult = ApplyCostsBrickPack(
    action,
    newBricks,
    newSets,
    newActionTimestamps,
    buyAmount,
  );

  if (costsResult === null) return state;

  // Apply Outcomes
  // null = default case was triggered
  const outcomesResult = ApplyOutcomesBrickPack(
    action,
    newBricks,
    newActionTimestamps,
    buyAmount,
    newBrickPackHistory,
    newBrickPackStats,
    state.brickPackUpgrades,
  );

  if (outcomesResult === null) return state;

  // Update achievement stats based on bricks added
  let totalBricksAdded = 0;
  outcomesResult.bricksAdded.forEach((count, brickId) => {
    totalBricksAdded += count;
    const currentCount = newBricksCollectedByType.get(brickId) || 0;
    newBricksCollectedByType.set(brickId, currentCount + count);
  });

  const newState = {
    ...state,
    actionTimestamps: newActionTimestamps,
    bricks: outcomesResult.newBricks,
    sets: newSets,
    actions: updatedActions,
    actionOrder: newActionOrder,
    brickPackHistory: newBrickPackHistory,
    brickPackStats: newBrickPackStats,
    totalBricksCollected: state.totalBricksCollected + totalBricksAdded,
    bricksCollectedByType: newBricksCollectedByType,
  };

  return applyAchievementChecks(newState);
};
